<template>
    <div class="code-bar-reader">
        <button class="code-bar-reader_btn-close" @click.prevent="$emit('close')">
            <img src="../assets/images/fecharx.svg" />
        </button>
        <div class="code-bar-reader_info">
            Posicione o código de barras sob a linha vermelha
            e aguarde a leitura automática
        </div>
        <stream-barcode-reader
                class="code-bar-reader_device"
                @decode="onDecode"
                @error="onError"
        ></stream-barcode-reader>
        <button type="button" class="code-bar-reader_btn-type" @click.prevent="closeBarReader">
            Digitar código de barras
        </button>
    </div>
</template>

<script>
    import { StreamBarcodeReader } from "vue-barcode-reader";
    import trackEvent from "../services/trackEvent";
    import {mapState} from "vuex";

    export default {
        name: "CodeBarReader",
        components: {
            StreamBarcodeReader
        },
        data () {
            return {
                detecteds: []
            }
        },
        computed: mapState({
            ac: state => state.ac,
            customer: state => state.customer,
        }),
        methods: {
            onDecode (result) {
                this.$emit('codeResult', result);
            },
            onError (error) {
                console.log(error);
            },
            closeBarReader() {
                trackEvent.track({
                    'user': {
                        'login': this.customer.login,
                        'loginType':  '',
                        'lineType':  this.customer.loginType,
                        'segment': this.customer.segment,
                        'subSegment':  this.customer.subSegment,
                        'planCode': this.customer.planCode,
                        'planName':  this.customer.planName
                    },
                    'channel': trackEvent.getChannel(),
                    'event-category': 6,
                    'event-label': 'Troca de Chip Digitar Codigo de Barras',
                    'event-value': null,
                    'event-status': 'Sucesso',
                    'event-interactionNumber': ''
                })
                this.$emit('close');
            }
        }
    }
</script>

<style lang="scss">
    .code-bar-reader {
        width: 100%;
        height: 100vh;
        display: block;
        align-items: center;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 2000;
        background: rgba(0,0,0,0.8);
        overflow-y: auto;
        > .code-bar-reader_btn-close {
            background: transparent;
            border: none;
            position: fixed;
            right: 15px;
            top: 30px;
            z-index: 1010;
        }
        > .code-bar-reader_info {
            width: 280px;
            height: auto;
            position: relative;
            display: block;
            top: 35px;
            margin: 0 auto;
            font-family: "timsans_regular";
            font-size: 1em;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.25;
            letter-spacing: normal;
            text-align: center;
            color: #ffffff;
        }
        > .code-bar-reader_device {
            width: 100%;
            height: auto;
            display: block;
            position: relative;
            margin: 100px auto 0 auto;
        }
        > .code-bar-reader_btn-type {
            width: 252px;
            height: 54px;
            display: block;
            position: relative;
            border-radius: 8px;
            border: solid 1px #ffff00;
            margin: 35px auto 0 auto;
            background: transparent;
            color: #ffff00;
            font-size: 0.875em;
            font-family: "timsans_regular";
            text-align: center;
            z-index: 1010;
        }
    }
</style>
